import React from 'react'
import PropTypes from 'prop-types'
import CallMadeIcon from '../../assets/CallMadeIcon'
import CallReceivedIcon from '../../assets/CallReceivedIcon'
import CallMissedIcon from '../../assets/CallMissedIcon'
import CallMadeMissedIcon from '../../assets/CallMadeMissedIcon'

const CallIconBox = (props) => {
  const { direction, callStart, callEnd } = props

  return (
    callEnd ?
      <div className="iconBox">
        {direction === 'inbound' && !callStart && <CallMissedIcon />}
        {direction === 'inbound' && callStart && <CallReceivedIcon />}
        {direction === 'outbound' && !callStart && <CallMadeMissedIcon />}
        {direction === 'outbound' && callStart && <CallMadeIcon />}
      </div> :
      <div className="iconBox" />
  )
}

CallIconBox.propTypes = {
  direction: PropTypes.string.isRequired,
  callStart: PropTypes.string,
  callEnd: PropTypes.string,
}

export default CallIconBox



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/CallIconBox.js